import {
  getSignupType,
  isFaireDirect,
  isWidget,
} from "@faire/retailer-visitor-shared/lib/signUpRevampUtils";
import {
  signUpStepper,
  nonFinalSteps,
} from "@faire/retailer-visitor-shared/views/SignUp/signUpSteps";
import { SignUpStepsStore } from "@faire/retailer-visitor-shared/views/SignUp/SignUpStepsContext";
import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useSignUpStepStoreValue = (): SignUpStepsStore => {
  const location = useLocation();
  const signUpType = useMemo(() => {
    return getSignupType(location);
  }, [location]);

  //don't include the faire direct survey step if the user is not signing up through faire direct
  const stepsFilterIfFD =
    isWidget(location) || isFaireDirect(location)
      ? nonFinalSteps
      : nonFinalSteps.filter((step) => step !== Step.FAIRE_DIRECT_SURVEY);
  const stepsToUse = stepsFilterIfFD;
  return useMemo(() => {
    return {
      currentStep: Step.PERSONAL_INFO,
      allSteps: stepsToUse,
      signUpType: signUpType,
      stepper: signUpStepper,
    };
  }, [signUpType, stepsToUse]);
};
